import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import HeroImage from "../../images/Kuva_hero.jpg";
import RegisterButton from './RegisterButton';
import { localizations } from '../../localization/localization';

const styles = (theme: Theme) => createStyles({
  image: {
    height: '42.875em',
    textAlign: 'right',
    backgroundImage: `url(${HeroImage})`,
    position: 'relative',
  },
  mobileImage: {
    height: '42.875em',
    textAlign: 'left',
    backgroundImage: `url(${HeroImage})`,
    position: 'relative',
  },
  gradient: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    left: 0,
    background: 'linear-gradient(180deg, rgba(2,38,57,0) 0%, #022639 100%)',
    height: '10.0625em',
    [theme.breakpoints.down('sm')]: {
      height: '30em'
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    lineHeight: 1.9375,
    paddingTop: '4.9375em',
    paddingLeft: '4.6875em',
    paddingRight: '4.6875em',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      padding: '1.75em'
    },
    '& > div:last-child': {
      marginTop: '1.875em'
    },
  },
  mobileContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    lineHeight: 1.9375,
    paddingTop: '6.9375em',
    paddingLeft: '4.6875em',
    paddingRight: '4.6875em',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      padding: '1.75em'
    },
    '& > div:last-child': {
      marginTop: '1.875em'
    },
  },
  title: {
    fontSize: '4.25em',
    fontWeight: 'bold',
    color: 'white',
    lineHeight: 1.2206,
    maxWidth: 804,
    [theme.breakpoints.down('sm')]: {
      fontSize: '3.5em',
    }
  },
  mobileTitle: {
    fontSize: '4.25em',
    fontWeight: 'bold',
    color: 'white',
    lineHeight: 1.2206,
    maxWidth: 804,
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.5em',
    }
  },
  description: {
    fontSize: '1.375em',
    maxWidth: 625
  },
  mobileDescription: {
    fontSize: '1.175em',
    maxWidth: 625
  }
});


const HeroContainer: React.SFC<WithStyles> = ({
  
  classes,
}) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  return (
    <Grid item container className={isMobile === false ? classes.image: classes.mobileImage}>
      <div className={classes.gradient} />
      <Grid item xs className={isMobile === false ? classes.content: classes.mobileContent}>
        <div className={isMobile === false ? classes.title: classes.mobileTitle}>
          {localizations.heroContainer.title}
        </div>
        <div className={isMobile === false ? classes.description : classes.mobileDescription}>
          {localizations.heroContainer.desc}
        </div>
        <div>
          <RegisterButton />
        </div>
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(HeroContainer);



// WEBPACK FOOTER //
// ./src/landingPage/components/HeroContainer.tsx